<template>
    <div>
        <el-row >
            <el-col :span="18" :offset="3" class="content">
                <img src="../../assets/wait.png" alt=""
                     style="margin: 10px auto;width: 120px;height: 120px;margin-top: 100px">
<!--                <div class="iconfont icon-chenggong"></div>-->
                <div class="title">资历正在审核中，请耐心等待...</div>
<!--                <div class="divider"></div>-->
                <div class="content-txt" style="margin-top: 80px">

                </div>
            </el-col>

        </el-row>

    </div>
</template>

<script>
    export default {
        name: "pause",
        data() {
            return {

            };
        },
        created() {
        },

        methods: {
            goEnter() {
                this.$router.push('/enter')
            }
        }
    }
</script>

<style scoped>
    @media only screen and (max-width: 768px) {
        .title {
            /*color: #666666 !important;*/
            /*font-size: 16px !important;*/
            /*font-weight: 600;*/
        }
    }
    .content {
        /*box-shadow: rgba(0,0,0,0.09) 0 6px 9px 0 ;*/
        padding: 15px 30px;
    }
    .title {
        color: #666666;
        font-size: 24px;
        font-weight: 600;
    }
    .divider {
        width: 100%;
        /*height: 1px;*/
        border-bottom: 1px dotted #4f589c;
        margin-top: 30px;
    }
    .content-txt {
        font-size: 18px;
        line-height: 3;
        letter-spacing: 2px;
        text-align: left;
        text-indent:2em;
        font-family: '楷体';
        font-weight: 600;
    }
    .icon-chenggong {
        color: #42b983;
        font-size: 140px;
        margin: 40px auto;
    }




</style>
